export enum AdditionalAreasType {
    BALCONY = 1,
    LOGGIA = 2,
    TERRACE = 3,
    GARDEN = 4,
    PARKING_PLACE = 8
}

export const getAdditionalAreasName = (type: AdditionalAreasType) => {
    switch (type) {
        case AdditionalAreasType.BALCONY:
            return "balkon";
        case AdditionalAreasType.LOGGIA:
            return "loggia";
        case AdditionalAreasType.TERRACE:
            return "taras";
        case AdditionalAreasType.GARDEN:
            return "ogródek";
        case AdditionalAreasType.PARKING_PLACE:
            return "miejsce postojowe";
        default:
            return "";
    }
};
export enum AdditionalAreasType {
    BALCONY = 1,
    LOGGIA = 2,
    TERRACE = 3,
    GARDEN = 4,
    PARKING_PLACE = 8
}

export const getAdditionalAreasName = (type: AdditionalAreasType) => {
    switch (type) {
        case AdditionalAreasType.BALCONY:
            return "balkon";
        case AdditionalAreasType.LOGGIA:
            return "loggia";
        case AdditionalAreasType.TERRACE:
            return "taras";
        case AdditionalAreasType.GARDEN:
            return "ogródek";
        case AdditionalAreasType.PARKING_PLACE:
            return "miejsce postojowe";
        default:
            return "";
    }
};
